<template>
  <div>
    <Nav />

    <main class="container">
      <h1 class="mt-5">Not found</h1>
    </main>
  </div>
</template>

<script>
  import Nav from '../components/Nav'

  export default {
    components: {
      Nav
    }
  }
</script>
